import React from 'react'
import { Col, Modal, Row } from 'antd'
import { MultiUploader } from 'Components/upload'

type Props = {
  token?: string
  isShow: boolean
  onClose: () => void
  productPhotos: string[]
  onUpdateData: (file: string[]) => void
  onSelectFile: (url: string) => void
}

const ChoosePhotosModal = (props: Props) => {
  const {
    isShow,
    onClose,
    productPhotos,
    token = '',
    onUpdateData = () => {},
    onSelectFile = () => {},
  } = props

  return (
    <Modal visible={isShow} title="เลือกรูปภาพ" onCancel={onClose} footer={null}>
      <Row>
        <Col>
          <MultiUploader
            folder="product"
            listType="picture-card"
            token={token}
            files={productPhotos}
            showSelect={true}
            onSelectFile={(file: any) => onSelectFile(file.uid)}
            onUpdateFile={onUpdateData}
            acceptType="image/png,image/jpeg"
            withCropImage={true}
            aspect={1}
            minFileSize={20}
          />
        </Col>
      </Row>
    </Modal>
  )
}

export default ChoosePhotosModal
